import React from 'react';
import GlobalModule from './components/Modules/GlobalModule';
import Router from './Router';

const App = () => {
  return (
    <GlobalModule>
      <Router />
    </GlobalModule>
  );
};

export default App;
